import { Injectable, Inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { NetworkGroupHeaderService } from './network-group-header.service';
@Injectable()
export class NetworkGroupHeaderInterceptor implements HttpInterceptor {
  constructor(private networkGroupHeaderService: NetworkGroupHeaderService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.method === 'JSONP') {
      return next.handle(request);
    }

    const networkGroupId = this.networkGroupHeaderService.networkGroupId();

    if (networkGroupId) {
      request = request.clone({
        setHeaders: {
          'fleet-network-group-id': networkGroupId,
        },
      });
    }

    return next.handle(request);
  }
}
